import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

import FilterListIcon from "@material-ui/icons/FilterList";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import Avatar from "@material-ui/core/Avatar";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CalendarViewDayOutlinedIcon from "@material-ui/icons/CalendarViewDayOutlined";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";

import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { AutocompleteList } from "../../Shared/CRM";

//import Filters from "./dialogs/Filters";

const { BRAND_NAME } = process.env;

const ReviewsSearch = () => {
	const classes = useStyles("Reviews");

	// MENU 1
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const [anchorEl2, setAnchorEl2] = React.useState(null);

	const handleClick2 = (event) => {
		setAnchorEl2(event.currentTarget);
	};

	const handleClose2 = () => {
		setAnchorEl2(null);
	};

	const [anchorEl3, setAnchorEl3] = React.useState(null);

	const handleClick3 = (event) => {
		setAnchorEl3(event.currentTarget);
	};

	const handleClose3 = () => {
		setAnchorEl3(null);
	};

	const [anchorEl4, setAnchorEl4] = React.useState(null);

	const handleClick4 = (event) => {
		setAnchorEl4(event.currentTarget);
	};

	const handleClose4 = () => {
		setAnchorEl4(null);
	};

	const data = [
		{
			name: "Ballet • Beginner Ballet - F",
			info: "Jan 1, 2024 – Dec 31, 2024",
			image:
				"https://assets-prd.ignimgs.com/2023/06/08/terminator-ill-be-back-line-1686225275248.jpg",
			cta: null,
		},
	];

	return (
		<Box borderRadius={8} bgcolor={"#f8f8fb"} p={4} mb={4}>
			<Box
				display={"flex"}
				flex={"1 1 auto"}
				alignItems={"center"}
				justifyContent={"space-between"}
				height={"100%"}
				flexWrap={{ xs: "wrap", sm: "wrap", md: "nowrap" }}
			>
				<Box width={"100%"} mr={3}>
					{/*https://material-ui.com/components/autocomplete/#asynchronous-requests*/}

					<AutocompleteList
						data={data}
						placeholder="Search keywords"
						toolTip="Search keywords"
						icon="search"
						size="small"
					/>
				</Box>

				<Box flexGrow={1} />

				<Box
					alignItems={"center"}
					justifyContent={"space-between"}
					display={"flex"}
				>
					<Box
						display={"flex"}
						alignItems={"center"}
						flexWrap={{ xs: "wrap", sm: "wrap", md: "nowrap" }}
					>
						<Box mr={3}>
							<Button
								size={"medium"}
								color={"secondary"}
								variant="outlined"
								endIcon={<ExpandMoreIcon />}
								className={classes.filterButton}
								onClick={handleClick3}
							>
								Any site
							</Button>

							<Menu
								id="sort-menu"
								anchorEl={anchorEl3}
								keepMounted
								open={Boolean(anchorEl3)}
								onClose={handleClose3}
							>
								<MenuItem
									onClick={handleClose}
									disabled
									className={classes.listPrimaryDisabled}
								>
									Filter by site
								</MenuItem>
								<MenuItem onClick={handleClose3} selected>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Radio
											edge="start"
											color="primary"
											checked
											tabIndex={-1}
											disableRipple
										/>
									</ListItemIcon>
									<ListItemText primary="All sites" />
								</MenuItem>
								<MenuItem onClick={handleClose3}>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Radio
											edge="start"
											color="primary"
											tabIndex={-1}
											disableRipple
										/>
									</ListItemIcon>
									<ListItemText primary={BRAND_NAME} />
								</MenuItem>
								<MenuItem onClick={handleClose3}>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Radio
											edge="start"
											color="primary"
											tabIndex={-1}
											disableRipple
										/>
									</ListItemIcon>
									<ListItemText primary="Google" />
								</MenuItem>
							</Menu>
						</Box>
						<Box mr={3}>
							<Button
								size={"medium"}
								color={"secondary"}
								variant="outlined"
								endIcon={<ExpandMoreIcon />}
								className={classes.filterButton}
								onClick={handleClick2}
							>
								Any rating
							</Button>

							<Menu
								id="sort-menu"
								anchorEl={anchorEl2}
								keepMounted
								open={Boolean(anchorEl2)}
								onClose={handleClose2}
							>
								<MenuItem
									onClick={handleClose2}
									disabled
									className={classes.listPrimaryDisabled}
								>
									Filter by rating
								</MenuItem>

								<MenuItem>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Checkbox
											edge="start"
											color="primary"
											tabIndex={-1}
											disableRipple
											checked
										/>
									</ListItemIcon>
									<ListItemText primary="5 stars" />
								</MenuItem>
								<MenuItem>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Checkbox
											edge="start"
											color="primary"
											tabIndex={-1}
											disableRipple
											checked
										/>
									</ListItemIcon>
									<ListItemText primary="4 stars" />
								</MenuItem>
								<MenuItem>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Checkbox
											edge="start"
											color="primary"
											tabIndex={-1}
											disableRipple
											checked
										/>
									</ListItemIcon>
									<ListItemText primary="3 stars" />
								</MenuItem>
								<MenuItem>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Checkbox
											edge="start"
											color="primary"
											tabIndex={-1}
											disableRipple
											checked
										/>
									</ListItemIcon>
									<ListItemText primary="2 stars" />
								</MenuItem>
								<MenuItem>
									<ListItemIcon style={{ minWidth: 32 }}>
										<Checkbox
											edge="start"
											color="primary"
											tabIndex={-1}
											disableRipple
											checked
										/>
									</ListItemIcon>
									<ListItemText primary="1 star" />
								</MenuItem>
							</Menu>
						</Box>

						<Button
							size={"medium"}
							color={"secondary"}
							variant="outlined"
							endIcon={<ExpandMoreIcon />}
							className={classes.filterButton}
							onClick={handleClick}
						>
							Any date
						</Button>

						<Menu
							id="sort-menu"
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleClose}
						>
							<MenuItem
								onClick={handleClose}
								disabled
								className={classes.listPrimaryDisabled}
							>
								Filter by date
							</MenuItem>
							<MenuItem onClick={handleClose}>Today</MenuItem>
							<MenuItem onClick={handleClose}>Yesterday</MenuItem>
							<MenuItem onClick={handleClose}>Last 7 days</MenuItem>
							<MenuItem onClick={handleClose}>Last 30 days</MenuItem>
							<MenuItem onClick={handleClose}>Last 90 days</MenuItem>
							<MenuItem onClick={handleClose}>Last month</MenuItem>
							<MenuItem onClick={handleClose}>Last year</MenuItem>
							<MenuItem onClick={handleClose}>Week to date</MenuItem>
							<MenuItem onClick={handleClose}>Month to date</MenuItem>
							<MenuItem onClick={handleClose}>Quarter to date</MenuItem>
							<MenuItem onClick={handleClose}>Year to date</MenuItem>
							<MenuItem onClick={handleClose}>Tomorrow</MenuItem>
							<MenuItem onClick={handleClose}>Next 7 days</MenuItem>
							<MenuItem onClick={handleClose}>Next month</MenuItem>
							<MenuItem onClick={handleClose}>Next 30 days</MenuItem>
							<MenuItem onClick={handleClose} selected>
								All time
							</MenuItem>
						</Menu>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

ReviewsSearch.propTypes = {};
export default ReviewsSearch;
